import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Files from '../views/Files.vue'
import Editor from '../views/Editor.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/files',
    name: 'Files',
    component: Files
  },
  {
    path: '/editor',
    name: 'Editor',
    component: Editor
  },
  {
    path: '/admin',
    name: 'AdminRedirect',
    component: {
      render: h => h('div', '正在跳转到管理页面...'),
      beforeRouteEnter(to, from, next) {
        window.location.href = 'admin.html'
      }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 添加全局导航守卫
router.beforeEach((to, from, next) => {
  // 如果是从编辑页面返回到文件列表页面
  if (from.path === '/editor' && to.path === '/files') {
    // 允许导航到文件列表页面
    next();
    // 导航完成后修改历史记录，防止用户通过浏览器返回按钮回到编辑页面
    router.app.$nextTick(() => {
      // 替换当前历史记录，使得用户无法通过浏览器返回按钮回到编辑页面
      window.history.replaceState(null, '', '/files');
    });
  } 
  // 如果是从登录页面跳转到文件列表页面
  else if (from.path === '/login' && to.path === '/files') {
    // 允许导航到文件列表页面
    next();
    // 导航完成后修改历史记录，防止用户通过浏览器返回按钮回到登录页面
    router.app.$nextTick(() => {
      // 替换当前历史记录，使得用户无法通过浏览器返回按钮回到登录页面
      window.history.replaceState(null, '', '/files');
    });
  }
  else {
    next();
  }
});

export default router 